module.exports = __webpack_public_path__ + "static/media/ambusher.28b0b244.png";